export { DEFAULT_CONFIGURATION, buildCookieOptions, } from './domain/configuration';
export { trackConsoleError } from './domain/error/trackConsoleError';
export { trackNetworkError } from './domain/error/trackNetworkError';
export { trackRuntimeError } from './domain/error/trackRuntimeError';
export { computeStackTrace } from './domain/tracekit';
export { BuildMode, defineGlobal, makePublicApi, commonInit, checkCookiesAuthorized, checkIsNotLocalFile, } from './boot/init';
export { monitored, monitor, callMonitored, addMonitoringMessage, addErrorToMonitoringBatch, setDebugMode, } from './domain/internalMonitoring';
export { Observable } from './tools/observable';
export { startSessionManagement, SESSION_TIME_OUT_DELAY, 
// Exposed for tests
SESSION_COOKIE_NAME, stopSessionManagement, } from './domain/sessionManagement';
export { HttpRequest, Batch } from './transport/transport';
export * from './tools/display';
export * from './tools/urlPolyfill';
export * from './tools/timeUtils';
export * from './tools/utils';
export * from './tools/errorFilter';
export { ErrorSource, ErrorHandling, formatUnknownError, createHandlingStack } from './tools/error';
export { areCookiesAuthorized, getCookie, setCookie, COOKIE_ACCESS_DELAY } from './browser/cookie';
export { startXhrProxy, resetXhrProxy } from './browser/xhrProxy';
export { startFetchProxy, resetFetchProxy, } from './browser/fetchProxy';
export { BoundedBuffer } from './tools/boundedBuffer';
export { catchUserErrors } from './tools/catchUserErrors';
export { createContextManager } from './tools/contextManager';
export { limitModification } from './tools/limitModification';
export { Datacenter } from './domain/transportConfiguration';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@datadog/browser-core/esm/index.js
// module id = 16
// module chunks = 0